export default "__VITE_ASSET__DeSolgxG__"